class MapFilterAddPageController {
  constructor(FiltersService, LoaderService, AlertService, $state) {
    this.FiltersService = FiltersService;
    this.LoaderService = LoaderService;
    this.AlertService = AlertService;
    this.$state = $state;
  }

  $onInit() {
    var self = this;
    self.validation = {};
    self.files = { pin: null, icon: null, home_location_filter: null };
    self.filter = angular.copy(self.FiltersService.getNew());
  }

  storeFile(picFile, type) {
    if (type === 'pin') {
      this.files.pin = picFile;
    }
    if (type === 'icon') {
      this.files.icon = picFile;
    }
    if (type === 'home_location_filter') {
      this.files.home_location_filter = picFile;
    }
  }

  save() {
    var self = this;
    if (!self.validForm()) {
      self.AlertService.error('The form has validation errors.');
      return;
    }

    self.LoaderService.start();
    self.FiltersService
      .addNew(self.filter, self.files)
      .then(() => {
        // empty the file array
        self.files = { pin: null, icon: null, home_location_filter: null };
        self.AlertService.success('Filter has been created');
        self.$state.go('app.map.filters', {}, { reload: true });
      })
      .catch(error => {
        if (error.type === 'image') {
          self.validation = {};
          if (error.field === 'icon') {
            self.files.icon = null;
            self.validation.iconImage = error.message;
          }
          if (error.field === 'pin') {
            self.files.pin = null;
            self.validation.pinImage = error.message;
          }

          if (error.field === 'home_location_filter') {
            self.files.home_location_filter = null;
            self.validation.featureImage = error.message;
          }
          self.AlertService.error('There was a problem saving the Filter');
        } else {
          self.AlertService.error('There was a problem saving the Filter');
        }
      })
      .finally(() => {
        self.LoaderService.stop();
      });
  }

  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if (self.filter.name === undefined || self.filter.name === '') {
      self.validation.name = 'Name is required';
    }
    if (self.files.pin === null) {
      self.validation.pinImage = 'You need to include a Pin image';
    }
    if (self.files.icon === null) {
      this.validation.iconImage = 'You need to include an Icon image';
    }
    if (self.files.home_location_filter === null) {
      this.validation.featureImage = 'You need to include a Feature image';
    }

    if (self.isEmpty(self.validation)) {
      return true;
    } else {
      return false;
    }
  }

  isEmpty(obj) {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    if (typeof obj !== 'object') return true;
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }
}
MapFilterAddPageController.$inject = [
  'FiltersService',
  'LoaderService',
  'AlertService',
  '$state'
];
export default MapFilterAddPageController;
